<template>
    <div @click="click()"
         :class="['radio-btn',
         {'active': checked},
         {'light': light},
         {'small': small},
         {'disabled': disabled},
         {'hide-radio': hideRadio}]">
        <slot></slot>
    </div>
</template>

<script>

    export default {
        name: "radio-btn",
        data() {
            return {
                checked: false,
                dataDisabled: false
            }
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            hideRadio: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.checked = this.value
            this.dataDisabled = this.disabled
        },
        methods: {
            click() {
                if (!this.dataDisabled) {
                    this.$emit("change", this.checked)
                }
            }
        },
        watch: {
            value(val) {
                this.checked = val
            },
            disabled(val) {
                this.dataDisabled = val
            }
        }
    }
</script>

<style scoped>
    .radio-btn {
        position: relative;
        display: grid;
        align-items: center;
        grid-template-columns: auto 1fr;
        grid-gap: 12px;
        cursor: pointer;
        transition: all .2s;
    }
    .radio-btn:before {
        content: "";
        width: 20px;
        height: 20px;
        border: 2px solid var(--lighten-7-color);
        border-radius: 50%;
        transition: all .2s;
        box-sizing: border-box;
    }
    .small.radio-btn:before {
        width: 14px;
        height: 14px;
    }
    .light.radio-btn:before {
        border: 2px solid var(--white-color);
    }
    .active.radio-btn:before {
        border: 2px solid var(--primary-color);
    }
    .light.active.radio-btn:before {
        border: 2px solid var(--white-color);
    }
    .hide-radio.radio-btn:before {
        opacity: 0;
    }
    .radio-btn:after {
        content: "";
        position: absolute;
        top: calc(50% - 5px);
        left: 5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: var(--primary-color);
        opacity: 0;
        transition: all .2s;
    }
    .small.radio-btn:after {
        top: calc(50% - 3px);
        left: 4px;
        width: 6px;
        height: 6px;
    }
    .light.radio-btn:after {
        background-color: var(--white-color);
    }
    .active.radio-btn:after {
        opacity: 1;
    }
    .hide-radio.radio-btn:after {
        opacity: 0;
    }
    .radio-btn.disabled {
        cursor: not-allowed;
    }
</style>
